<template>
  <div class="col-12" v-if="showSkonto">
    <template v-if="variationTotalPrice">
      <div class="my-4">
        <span v-html="$translate('ZeitloungeTheme::Template.articleSkontoHtmlText')"></span>
        <span>
          {{ skontoPrice | currency(currentVariation.prices.default.currency) }} * 
        </span>
      </div>
    </template>
  </div>
</template>


<script>
export default { 
    name: "article-skonto", 
    inject: {
        itemId: {
            default: null
        }
    },
    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        showSkonto() {
          return this.$translate('ZeitloungeTheme::Template.articleSkontoHtmlText') && (App.activeCurrency == 'EUR' || App.activeCurrency == '€');
        },
        variationTotalPrice() {
            return this.$store.getters[`${ this.currentVariation.item.id }/variationTotalPrice`];
        },
        skontoPrice() {
            return (this.variationTotalPrice * 0.97).toFixed(2);
        }

    }
}
</script>
